export default __webpack_public_path__ + "static/media/icono.10cc1184.png";